<template>
    <div>
        <v-card class="my-3 pl-2 pr-2">
            <v-text-field
                :label="label"
                v-model="inputValue"
                @keyup.enter="addItem"
                hide-details
            ></v-text-field>

            <v-divider></v-divider>

            <v-container>
                <v-row>
                    <v-col v-for="(item, index) in localItems" :key="index" cols="auto">
                        <v-chip close @click:close="removeItem(index)">{{ item }}</v-chip>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'zoezi-item-list-setting',

    props: ['label', 'value'],

    data: () => ({
        inputValue: '',
        localItems: []
    }),

    computed: {
        items: {
            get() {
                return this.localItems;
            },
            set(newValue) {
                this.localItems = newValue;
                this.$emit('input', this.localItems);
            }
        }
    },

    watch: {
        value: {
            immediate: true,
            handler(newValue) {
                this.localItems = newValue || [];
            }
        }
    },

    methods: {
        addItem() {
            if (this.inputValue.trim()) {
                this.localItems.push(this.inputValue.trim());
                this.inputValue = '';
                this.$emit('input', this.localItems);
            }
        },
        removeItem(index) {
            this.localItems.splice(index, 1);
            this.$emit('input', this.localItems);
        }
    }
}
</script>

<style>
    .v-card {
        border-radius: 0;
    }
    .v-container {
        padding-top: 0;
        padding-bottom: 0;
    }
</style>
